import React from 'react'

import tinycolor from 'tinycolor2'

import { cn } from '../../ui/cn'

const PadTrackName: React.FC<{
  name: string
  color: string
  hasImage: boolean
}> = ({ name, color, hasImage }) => {
  const textColor = hasImage
    ? tinycolor.mostReadable(color, ['#222', '#fff']).toHexString()
    : undefined

  return (
    <div
      className={cn(
        'shrink cursor-pointer overflow-hidden text-ellipsis break-all rounded-[0.2rem] text-base font-normal leading-tight',
        hasImage ? 'px-1' : 'px-0',
      )}
      style={{
        border: hasImage ? `1px solid ${color}` : undefined,
        backgroundColor: hasImage ? color : undefined,
        color: textColor,
      }}
    >
      {name}
    </div>
  )
}

export default PadTrackName
